"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Widget = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Core_1 = require("./Core");
var Text_1 = __importDefault(require("./Text"));
var PADDING_BOTTOM = "32px";
var Widget = function (_a) {
    var description = _a.description, title = _a.title, imageSrc = _a.imageSrc, onClick = _a.onClick;
    var colors = (0, styled_components_1.useTheme)().colors;
    return (react_1.default.createElement(Clickable, { flexShrink: 0, maxWidth: 400, p: "16px 8px ".concat(PADDING_BOTTOM, " 24px"), bg: colors.white, border: "1px solid ".concat(colors.grey4), borderRadius: 8, onClick: onClick, clickable: Boolean(onClick), tabIndex: 0 },
        react_1.default.createElement(Core_1.Flex, { gap: 18, alignItems: "flex-end" },
            react_1.default.createElement(Core_1.Box, null,
                react_1.default.createElement(Text_1.default, { size: 24, bold: true }, title),
                react_1.default.createElement(Text_1.default, null, description)),
            react_1.default.createElement(Img, { src: imageSrc, alt: "Responses Icon" }))));
};
exports.Widget = Widget;
var Clickable = (0, styled_components_1.default)(Core_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: box-shadow 0.2s linear;\n  &:hover,\n  &:focus {\n    box-shadow: ", ";\n    cursor: ", ";\n    outline: none;\n  }\n"], ["\n  transition: box-shadow 0.2s linear;\n  &:hover,\n  &:focus {\n    box-shadow: ", ";\n    cursor: ", ";\n    outline: none;\n  }\n"])), function (p) { return p.clickable && "0px 4px 8px rgba(0, 0, 0, 0.15)"; }, function (p) { return p.clickable && "pointer"; });
var Img = styled_components_1.default.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  transform: translateY(", ");\n"], ["\n  transform: translateY(", ");\n"])), PADDING_BOTTOM);
var templateObject_1, templateObject_2;
